import { createRouter, createWebHistory } from "vue-router";
import { LoginView } from "./modules/session";
import { CharacterView } from "./modules/characters";
import { GameShellView } from "./modules/shell";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "login", component: LoginView },
    { path: "/characters", name: "characters", component: CharacterView },
    { path: "/game", name: "game", component: GameShellView },
    { path: "/area", redirect: "/game" }
  ]
});

export default router;
